


























































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class PriceCards extends Vue {
    bestUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/Best.png'
}
